export enum UserTeamType {
  Viewer = 0,
  Manager = 1,
  Admin = 2,
}
